import { MaintenancePage } from 'components/general-settings/maintenance-page/MaintenancePage'
import { useEffect, useState } from 'react'
import { useValidation } from 'hooks/useValidation'
import { MAINTENANCE_PAGE_VALIDATION } from 'services/validation/maintenancePageValidation'
import { convertErrorMessage, uploadFileToS3 } from 'utils/utils'
import { useFetch } from 'services/useFetch'
import { API_MAINTENANCE_PAGE } from 'services/apiMaintenancePage'
import { Alert } from 'avo-ui'

const INITIAL_STATE = {
    title: null,
    description: null,
    image_url: null,
    platform_status: [],
}

const FIELD_NAME_DETAIL = {
    title: 'Title',
    description: 'Description',
    image_url: 'Image',
    platform_status: 'Platform',
}

export const MaintenancePageContainer = () => {
    const [reload, setReload] = useState(false)
    const [maintenancePageDetail, setMaintenancePageDetail] = useState(INITIAL_STATE)
    const [isLoadingUpload, setIsLoadingUpload] = useState(false)
    const [errorMessage, setErrorMessage] = useState({})
    const { fetching: getMaintenancePageDetail, isLoading } = useFetch(API_MAINTENANCE_PAGE.DETAIL)
    const { fetching: getUrlImageTitle } = useFetch(API_MAINTENANCE_PAGE.URL_IMAGE_TITLE)
    const { fetching: updateMaintenancePage, isLoading: isUpdating } = useFetch(API_MAINTENANCE_PAGE.UPDATE)
    const { validateForm, errorForm } = useValidation({
        form: maintenancePageDetail,
        schema: MAINTENANCE_PAGE_VALIDATION,
    })

    const onChangeForm = (e) => {
        const { name, value, checked } = e
        let newData
        if (checked === undefined) {
            newData = { [name]: value }
        } else {
            const newStatus = maintenancePageDetail?.platform_status?.map((item) => {
                if (item?.name === name) return { ...item, value: checked }
                return item
            })
            newData = { platform_status: newStatus }
        }

        setMaintenancePageDetail({ ...maintenancePageDetail, ...newData })
    }

    const setUploadImage = async () => {
        const image = maintenancePageDetail?.image_url
        try {
            const s3Urls = await getUrlImageTitle({ filename: image?.name?.replace(/\s/g, '') })
            await uploadFileToS3(s3Urls?.data, image?.file)
            onSave(`${s3Urls?.data?.url}${s3Urls?.data?.fields.key}`)
        } catch (err) {
            console.log('upload failed')
        }

        setIsLoadingUpload(false)
    }

    const onSubmit = () => {
        setErrorMessage({})
        validateForm().then(() => {
            if (maintenancePageDetail?.image_url?.name) {
                setIsLoadingUpload(true)
                setUploadImage()
            } else {
                onSave()
            }
        })
    }

    const onSave = (url = maintenancePageDetail?.image_url) => {
        const payload = {
            ...maintenancePageDetail,
            image_url: url,
        }
        updateMaintenancePage(payload)
            .then(() => {
                setReload(!reload)
                return Alert({
                    icon: 'success',
                    title: 'Success',
                    message: 'Maintenance Page Updated !',
                })
            })
            .catch((error) => setErrorMessage(convertErrorMessage(error?.data, FIELD_NAME_DETAIL)))
    }

    useEffect(() => {
        getMaintenancePageDetail().then((response) => setMaintenancePageDetail({ ...response?.data }))
    }, [reload])

    const props = {
        maintenancePageDetail,
        errorForm: { ...errorForm, ...errorMessage },
        onChangeForm,
        isLoading,
        isUpdating,
        isLoadingUpload,
        onSubmit,
    }

    return <MaintenancePage {...props} />
}
